var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"},attrs:{"placeholder":"Select From User","options":_vm.users},on:{"search:blur":_vm.selectedUser},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})
}
var staticRenderFns = []

export { render, staticRenderFns }